import validator from 'validator';
import DOMPurify from 'dompurify';

export default (val) => (
  validator.blacklist(DOMPurify.sanitize(val), '<>"')
);



// WEBPACK FOOTER //
// ./src/utils/sanitiser.js